export default "__VITE_ASSET__daFzaeVe__"